import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface feedbackState {
    data: [] | null | any;
    totalPages: number | null;
    currentPage: number | null;
    totalRecords: number | null;
}

const initialState: feedbackState = {
    data: null,
    totalPages: null,
    currentPage: null,
    totalRecords: null,
};

export const feedbackSlice = createSlice({
    name: "feedback",
    initialState,
    reducers: {
        setFeedBack: (state, action) => {
            state.data = action.payload.data;
            state.totalPages = action.payload.totalPages;
            state.currentPage = action.payload.currentPage;
            state.totalRecords = action.payload.totalRecords;
        },

        reset: (state) => {
            state = initialState;
        },
    },
});

export const { setFeedBack, reset } =
    feedbackSlice.actions;
export const getBookingDetails = (state: RootState) => state.feedback.data;
export const getTotalRecord = (state: RootState) => state.feedback.totalRecords;
export const getTotalPage = (state: RootState) => state.feedback.totalPages;

export default feedbackSlice.reducer;
